import { useEffect, useState } from "react";
import { motion, useAnimate, useMotionValueEvent, useScroll } from "framer-motion";
import MainBoard from "../Components/Comms/MainBoard";
import SmoothScrolling from '../Components/SmoothScrolling';
import TitleBar from "../Components/Comms/TitleBar";
import "./Comms.css";
import { Parallax } from 'react-scroll-parallax';
import LoadingHome from "../Components/Home/LoadingHome";
import SubmissionSection from "../Components/Comms/SubmissionSection";
import { isMobile } from "react-device-detect";

export default function Comms() {
    const [mousePosition, setMousePosition] = useState({
        x: 0,
        y: 0
    });
    const [cursorVariant, setCursorVariant] = useState("default");
    useEffect(() => {
        const mouseMove = (e: { clientX: any; clientY: any; }) => {
            setMousePosition({
                x: e.clientX,
                y: e.clientY
            });
        }

        window.addEventListener("mousemove", mouseMove);
        window.scrollTo(0, 0);

        return () => {
            window.removeEventListener("mousemove", mouseMove);
        }
    }, []);
    const cursorVariants = {
        default: {
            x: mousePosition.x - 16,
            y: mousePosition.y - 16,
            transition: {
                mode: "smooth",
                duration: 0,
            }
        },
        link: {
            height: 10,
            width: 10,
            x: mousePosition.x - 5,
            y: mousePosition.y - 5,
            transition: {
                mode: "smooth",
                duration: 0
            }
        },
        dark: {
            height: 10,
            width: 10,
            x: mousePosition.x - 5,
            y: mousePosition.y - 5,
            transition: {
                mode: "smooth",
                duration: 0,
            },
            backgroundColor: "#8c8782"
        }
    };
    const { scrollYProgress } = useScroll();
    const [scope, animate] = useAnimate();
    const [hidden, setHidden] = useState(false);
    const triangleVariants = {
        visible: { opacity: 1 },
        hidden: { opacity: 0 }
    }
    useMotionValueEvent(scrollYProgress, "change", (latest) => {
        latest > 0 ? setHidden(true) : setHidden(false);
    })
    async function bounceAnimation() {
        await animate(scope.current, { opacity: 0 });
        await animate(scope.current, { opacity: 1 }, { delay: 2 });
        animate(
            scope.current,
            {
                y: ["0%", "100%", "0%"]
            },
            {
                repeat: Infinity,
                ease: "easeInOut",
                duration: 2
            }
        )
    }
    useEffect(() => {
        bounceAnimation();
        // eslint-disable-next-line
    }, []);

    const titleParallaxSpeed = 20;
    const cursorLinkEnter = () => setCursorVariant("link");
    const cursorDarkEnter = () => setCursorVariant("dark");
    const cursorLeave = () => setCursorVariant("default");

    return (
        <>
            <LoadingHome imagesLoaded={true} />

            {
                isMobile ?
                    <div className="comm-section-container" >
                        <div className="clouds-container">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1296 1325">
                                <path d="M625 0C638.491 0 651.171 3.76374 662.198 10.374C670.039 7.55047 678.573 6 687.5 6C725.884 6 757 34.6538 757 70C757 70.5328 756.993 71.0641 756.979 71.5938C774.898 76.4794 788 92.0479 788 110.5C788 110.817 787.995 111.133 787.987 111.448C848.521 116.644 896 166.394 896 227C896 234.093 895.348 241.037 894.103 247.779C917.37 251.802 935 270.965 935 294C935 305.172 930.85 315.432 923.924 323.497C930.79 331.084 937.172 339.701 943.031 349.487C1000.23 354.797 1045 402.919 1045 461.5C1045 464.753 1044.86 467.973 1044.59 471.156C1067.7 483.654 1085.58 507.947 1093.11 537.785C1105.19 547.551 1113 563.049 1113 580.5C1113 585.165 1112.44 589.689 1111.39 594.003C1111.59 594.002 1111.8 594 1112 594C1127.84 594 1142.86 597.373 1156.3 603.404C1162.29 595.281 1172.02 590 1183 590C1188.32 590 1193.35 591.244 1197.81 593.449C1218.4 559.052 1254.12 534.438 1296 528.424V1413H0V564.093C3.21962 563.379 6.56556 563 10 563C29.1557 563 45.5735 574.71 52.4932 591.361C69.3619 584.675 87.7516 581 107 581C113.713 581 120.32 581.45 126.796 582.315C135.165 561.475 153.602 547 175 547C180.822 547 186.424 548.072 191.664 550.052C201.109 535.034 214.115 522.483 229.499 513.584C234.019 471.071 268.783 438 311 438C311.708 438 312.414 438.009 313.118 438.027C320.654 423.222 332.962 411.253 348.015 404.145C348.703 369.845 375.449 341.539 410.422 335.987C410.143 333.694 410 331.363 410 329C410 322.099 411.221 315.466 413.472 309.28C383.705 286.771 365 254.214 365 218C365 150.069 430.814 95 512 95C513.007 95 514.011 95.0105 515.013 95.0273C523.593 79.9772 535.789 69.4059 549.676 66.0986C557.058 28.3353 587.977 0 625 0Z" fill="rgb(220, 212, 195)" />
                            </svg>
                        </div>
                        <div className="sea" />
                        <div className="reflection-container">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1296 805">
                                <path d="M1296 276.576C1254.12 270.562 1218.4 245.948 1197.81 211.551C1193.35 213.756 1188.32 215 1183 215C1172.02 215 1162.29 209.719 1156.3 201.596C1142.86 207.627 1127.84 211 1112 211C1111.8 211 1111.59 210.998 1111.39 210.997C1112.44 215.311 1113 219.835 1113 224.5C1113 241.951 1105.19 257.449 1093.11 267.215C1085.58 297.053 1067.7 321.346 1044.59 333.844C1044.86 337.027 1045 340.247 1045 343.5C1045 402.081 1000.23 450.203 943.031 455.513C937.172 465.299 930.79 473.916 923.924 481.503C930.85 489.568 935 499.828 935 511C935 534.035 917.37 553.198 894.103 557.221C895.348 563.963 896 570.907 896 578C896 638.606 848.521 688.356 787.987 693.552C787.995 693.867 788 694.183 788 694.5C788 712.952 774.898 728.521 756.979 733.406C756.993 733.936 757 734.467 757 735C757 770.346 725.884 799 687.5 799C678.573 799 670.039 797.45 662.198 794.626C651.171 801.236 638.491 805 625 805C587.977 805 557.058 776.665 549.676 738.901C535.789 735.594 523.593 725.023 515.013 709.973C514.011 709.99 513.007 710 512 710C430.814 710 365 654.931 365 587C365 550.786 383.705 518.229 413.472 495.72C411.221 489.534 410 482.901 410 476C410 473.637 410.143 471.306 410.422 469.013C375.449 463.461 348.703 435.155 348.015 400.855C332.962 393.747 320.654 381.778 313.118 366.973C312.414 366.991 311.708 367 311 367C268.783 367 234.019 333.929 229.499 291.416C214.115 282.517 201.109 269.966 191.664 254.948C186.424 256.928 180.822 258 175 258C153.602 258 135.165 243.525 126.796 222.685C120.32 223.55 113.713 224 107 224C87.7516 224 69.3619 220.325 52.4932 213.639C45.5735 230.29 29.1557 242 10 242C6.56556 242 3.21962 241.621 0 240.907V0H1296V276.576Z" fill="rgba(255, 255, 255, 0.25)" />
                            </svg>
                        </div>
                        <TitleBar />
                        <motion.div
                            className="triangle-container"
                            variants={triangleVariants}
                            animate={hidden ? "hidden" : "visible"}
                            transition={{ ease: [0.1, 0.25, 0.3, 1], duration: 0.6 }}
                        >
                            <motion.div
                                ref={scope}
                                className='triangle-down'
                            />
                        </motion.div>
                        <MainBoard />
                        <SubmissionSection cursorLinkEnter={cursorLinkEnter} cursorEnter={cursorDarkEnter} cursorLeave={cursorLeave} />
                    </div>
                    :
                    <SmoothScrolling>
                        <div className="comm-section-container" >
                            <div className="clouds-container">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1296 1325">
                                    <path d="M625 0C638.491 0 651.171 3.76374 662.198 10.374C670.039 7.55047 678.573 6 687.5 6C725.884 6 757 34.6538 757 70C757 70.5328 756.993 71.0641 756.979 71.5938C774.898 76.4794 788 92.0479 788 110.5C788 110.817 787.995 111.133 787.987 111.448C848.521 116.644 896 166.394 896 227C896 234.093 895.348 241.037 894.103 247.779C917.37 251.802 935 270.965 935 294C935 305.172 930.85 315.432 923.924 323.497C930.79 331.084 937.172 339.701 943.031 349.487C1000.23 354.797 1045 402.919 1045 461.5C1045 464.753 1044.86 467.973 1044.59 471.156C1067.7 483.654 1085.58 507.947 1093.11 537.785C1105.19 547.551 1113 563.049 1113 580.5C1113 585.165 1112.44 589.689 1111.39 594.003C1111.59 594.002 1111.8 594 1112 594C1127.84 594 1142.86 597.373 1156.3 603.404C1162.29 595.281 1172.02 590 1183 590C1188.32 590 1193.35 591.244 1197.81 593.449C1218.4 559.052 1254.12 534.438 1296 528.424V1413H0V564.093C3.21962 563.379 6.56556 563 10 563C29.1557 563 45.5735 574.71 52.4932 591.361C69.3619 584.675 87.7516 581 107 581C113.713 581 120.32 581.45 126.796 582.315C135.165 561.475 153.602 547 175 547C180.822 547 186.424 548.072 191.664 550.052C201.109 535.034 214.115 522.483 229.499 513.584C234.019 471.071 268.783 438 311 438C311.708 438 312.414 438.009 313.118 438.027C320.654 423.222 332.962 411.253 348.015 404.145C348.703 369.845 375.449 341.539 410.422 335.987C410.143 333.694 410 331.363 410 329C410 322.099 411.221 315.466 413.472 309.28C383.705 286.771 365 254.214 365 218C365 150.069 430.814 95 512 95C513.007 95 514.011 95.0105 515.013 95.0273C523.593 79.9772 535.789 69.4059 549.676 66.0986C557.058 28.3353 587.977 0 625 0Z" fill="rgb(220, 212, 195)" />
                                </svg>
                            </div>
                            <div className="sea" />
                            <div className="reflection-container">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1296 805">
                                    <path d="M1296 276.576C1254.12 270.562 1218.4 245.948 1197.81 211.551C1193.35 213.756 1188.32 215 1183 215C1172.02 215 1162.29 209.719 1156.3 201.596C1142.86 207.627 1127.84 211 1112 211C1111.8 211 1111.59 210.998 1111.39 210.997C1112.44 215.311 1113 219.835 1113 224.5C1113 241.951 1105.19 257.449 1093.11 267.215C1085.58 297.053 1067.7 321.346 1044.59 333.844C1044.86 337.027 1045 340.247 1045 343.5C1045 402.081 1000.23 450.203 943.031 455.513C937.172 465.299 930.79 473.916 923.924 481.503C930.85 489.568 935 499.828 935 511C935 534.035 917.37 553.198 894.103 557.221C895.348 563.963 896 570.907 896 578C896 638.606 848.521 688.356 787.987 693.552C787.995 693.867 788 694.183 788 694.5C788 712.952 774.898 728.521 756.979 733.406C756.993 733.936 757 734.467 757 735C757 770.346 725.884 799 687.5 799C678.573 799 670.039 797.45 662.198 794.626C651.171 801.236 638.491 805 625 805C587.977 805 557.058 776.665 549.676 738.901C535.789 735.594 523.593 725.023 515.013 709.973C514.011 709.99 513.007 710 512 710C430.814 710 365 654.931 365 587C365 550.786 383.705 518.229 413.472 495.72C411.221 489.534 410 482.901 410 476C410 473.637 410.143 471.306 410.422 469.013C375.449 463.461 348.703 435.155 348.015 400.855C332.962 393.747 320.654 381.778 313.118 366.973C312.414 366.991 311.708 367 311 367C268.783 367 234.019 333.929 229.499 291.416C214.115 282.517 201.109 269.966 191.664 254.948C186.424 256.928 180.822 258 175 258C153.602 258 135.165 243.525 126.796 222.685C120.32 223.55 113.713 224 107 224C87.7516 224 69.3619 220.325 52.4932 213.639C45.5735 230.29 29.1557 242 10 242C6.56556 242 3.21962 241.621 0 240.907V0H1296V276.576Z" fill="rgba(255, 255, 255, 0.25)" />
                                </svg>
                            </div>
                            <motion.div
                                className='comm-cursor'
                                variants={cursorVariants}
                                animate={cursorVariant}
                            />
                            <Parallax speed={titleParallaxSpeed}>
                                <TitleBar />
                                <motion.div
                                    className="triangle-container"
                                    variants={triangleVariants}
                                    animate={hidden ? "hidden" : "visible"}
                                    transition={{ ease: [0.1, 0.25, 0.3, 1], duration: 0.6 }}
                                >
                                    <motion.div
                                        ref={scope}
                                        className='triangle-down'
                                    />
                                </motion.div>
                            </Parallax>
                            <Parallax speed={titleParallaxSpeed / 2}>
                                <MainBoard />
                            </Parallax>
                            <SubmissionSection cursorLinkEnter={cursorLinkEnter} cursorEnter={cursorDarkEnter} cursorLeave={cursorLeave} />
                        </div>
                    </SmoothScrolling>
            }
        </>
    );
}